export default __webpack_public_path__ + "static/media/aboutus_card_icon3.9cb0d9b9.svg";